import {
  NumberInput,
  NumberInputField,
  NumberInputProps,
} from "@chakra-ui/react";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface IntegerFieldProps extends BaseFieldProps {}

const parseValue = (value: string) => {
  const parsed = value.replace(/[\$,]/g, "");

  if (parsed === "") {
    return "";
  }

  return parsed;
};

export const IntegerField = ({
  name,
  label,
  id,
  horizontal,
  labelProps,
  valueProps,
  ...numberInputProps
}: IntegerFieldProps & NumberInputProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      horizontal={horizontal}
      labelProps={labelProps}
      valueProps={valueProps}
    >
      {({ field, form }) => {
        return (
          <NumberInput
            precision={0}
            value={field.value != null ? field.value : undefined}
            onChange={(strValue) => {
              form.setFieldValue(field.name, parseValue(strValue), true);
            }}
            onBlur={field.onBlur}
            name={field.name}
            pattern="[0-9]*"
            backgroundColor="white"
            w="100%"
            {...numberInputProps}
          >
            <NumberInputField placeholder={numberInputProps.placeholder} />
          </NumberInput>
        );
      }}
    </FieldWrapper>
  );
};
